/**
 * IDs das Features - Nova estrutura de permissões
 * 
 * IMPORTANTE: 
 * - Use sempre estes IDs nas rotas e verificações de permissão
 * - IDs nunca mudam, apenas nomes podem ser alterados
 * - Baseado na documentação da API v2.0
 */

// IDs das Features por categoria (ATUALIZADOS para seguir documentação oficial)
export const FEATURE_IDS = {
  // AGENTES IA
  MEUS_AGENTES: 1,
  MEUS_AGENTES2: 25,
  CRIAR_AGENTE: 2,
  EDITAR_AGENTE: 22, // NOVO: baseado na documentação
  PLAYGROUND: 3,

  // ATENDIMENTO
  CHAT: 4,
  AGENDA: 7,

  // CLIENTES & VENDAS
  BASE_CLIENTES: 5,
  CRM_PIPELINE: 6,

  // AUTOMAÇÕES
  TEMPLATES: 8,
  AUTOMACOES: 9,

  // COMUNICAÇÃO
  WHATSAPP: 10,
  CANAIS: 23,
  INTEGRACOES: 11, // Nova feature para overview de integrações

  // CONFIGURAÇÕES
  MINHA_EMPRESA: 15,
  MEU_PERFIL: 16,
  TAGS_CATEGORIAS: 17,

  // SUPORTE
  SUPORTE: 18,

  // ADMINISTRAÇÃO
  USUARIOS: 20,

  // ADMINISTRAÇÃO (is_staff = true)
  ADMIN_USUARIOS: 28,
  ADMIN_TREINAMENTOS: 29,
  ADMIN_CURSOS: 30,
};

// Mapeamento de rotas para IDs de features (ATUALIZADO)
export const ROUTE_TO_FEATURE_ID = {
  // Agentes
  "/agents": FEATURE_IDS.MEUS_AGENTES,
  "/agents/create": FEATURE_IDS.CRIAR_AGENTE,
  "/agents/:id": FEATURE_IDS.EDITAR_AGENTE,
  "/playground": FEATURE_IDS.PLAYGROUND,

  // Atendimento
  "/chat": FEATURE_IDS.CHAT,
  "/service-center": FEATURE_IDS.CHAT,
  "/calendar": FEATURE_IDS.AGENDA,

  // Clientes
  "/customers": FEATURE_IDS.BASE_CLIENTES,
  "/general-customers": FEATURE_IDS.BASE_CLIENTES,
  "/customer-details": FEATURE_IDS.BASE_CLIENTES,
  "/crm": FEATURE_IDS.CRM_PIPELINE,

  // Automações
  "/templates": FEATURE_IDS.TEMPLATES,
  "/automations": FEATURE_IDS.AUTOMACOES,

  // Comunicação
  "/channels": FEATURE_IDS.CANAIS,

  // Configurações
  "/user-details": FEATURE_IDS.MEU_PERFIL,
  "/business-settings": FEATURE_IDS.MINHA_EMPRESA,
  "/tags": FEATURE_IDS.TAGS_CATEGORIAS,

  // Suporte
  "/support": FEATURE_IDS.SUPORTE,

  // Administração
  "/users": FEATURE_IDS.USUARIOS,
};

// Categorias das features
export const FEATURE_CATEGORIES = {
  AGENTES: 'agentes',
  ATENDIMENTO: 'atendimento', 
  CLIENTES_VENDAS: 'clientes_vendas',
  AUTOMACOES: 'automacoes',
  INTEGRACOES: 'integracoes',
  TREINAMENTOS: 'treinamentos',
  CONFIGURACOES: 'configuracoes',
  SUPORTE: 'suporte',
  MARKETPLACE: 'marketplace',
  ORGANIZACAO: 'organizacao',
  FINANCEIRO: 'financeiro',
};

// Helper function para obter ID da feature por rota
export const getFeatureIdByRoute = (route) => {
  return ROUTE_TO_FEATURE_ID[route] || null;
};

// Helper function para verificar se uma rota requer permissão específica
export const routeRequiresPermission = (route) => {
  return ROUTE_TO_FEATURE_ID.hasOwnProperty(route);
};